// src/components/Question.tsx
import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

interface QuestionProps {
  question: string;
  id: number;
  value: string;
  onChange: (id: number, value: string) => void;
}

const Question: React.FC<QuestionProps> = ({ question, id, value, onChange }) => {
  return (
    <FormControl component="fieldset" fullWidth margin="normal">
      <FormLabel component="legend">{question}</FormLabel>
      <RadioGroup
        row
        name={`question-${id}`}
        value={value}
        onChange={(e) => onChange(id, e.target.value)}
      >
        <FormControlLabel value="0" control={<Radio />} label="Never" />
        <FormControlLabel value="1" control={<Radio />} label="Rarely" />
        <FormControlLabel value="2" control={<Radio />} label="Sometimes" />
        <FormControlLabel value="3" control={<Radio />} label="Often" />
        <FormControlLabel value="4" control={<Radio />} label="Very Often" />
      </RadioGroup>
    </FormControl>
  );
};

export default Question;